import { render, staticRenderFns } from "./BookTypeOption.vue?vue&type=template&id=451f187f"
import script from "./BookTypeOption.vue?vue&type=script&lang=js"
export * from "./BookTypeOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports